/* Company details panel — the card at the top of Business Profile.
   Styled by src/styles/billing.css (.panel/.bp-co-*), so it must render inside
   a .tf-billing scope; the page already provides one. */
import { useSelector } from "react-redux";

// Icons
import { I } from "../../billing/icons";

// Page specific components
import BusinessProofBlock, {
  ProofBadge,
  proofStatus
} from "../BusinessProofBlock";

const externalHref = url =>
  /^https?:\/\//i.test(url) ? url : `https://${url}`;

const Field = ({ label, value, icon, link }) => (
  <div>
    <div className="bp-co-lbl">{label}</div>
    <div className="bp-co-val">
      {icon && <span className="bp-co-ico">{icon}</span>}
      {!value ? (
        <span className="bp-co-empty">Not set</span>
      ) : link ? (
        <a href={externalHref(value)} target="_blank" rel="noreferrer">
          {value}
        </a>
      ) : (
        value
      )}
    </div>
  </div>
);

const BusinessProfileDetails = ({ business, location, ping }) => {
  const { activeBranch } = useSelector(state => state.app);

  if (!business || !location) return null;

  return (
    <div className="panel">
      <div className="panel-head">
        <div className="panel-eyebrow">Company details</div>
        <ProofBadge status={proofStatus(business)} />
      </div>
      <div className="panel-body">
        <div className="bp-co-grid">
          <Field label="Business Name" value={business.name} />
          <Field
            label="HQ Address"
            value={location.address}
            icon={<I.MapPin width="13" height="13" />}
          />
          <Field
            label="Tax Identification Number"
            value={business.taxId}
          />
          <Field label="State" value={location.state} />
          <Field label="ZIP / Postal Code" value={location.postalCode} />
          <Field label="Website" value={business.websiteUrl} link />
        </div>

        <div className="divider" style={{ margin: "22px 0 18px" }} />

        <BusinessProofBlock
          business={business}
          location={location}
          branchName={activeBranch?.name}
          ping={ping}
        />
      </div>
    </div>
  );
};

export default BusinessProfileDetails;
